import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "professionalType",
    "dentistLimitMessage",
    "submit",
    "htmlForconfirmSweetPlanChange",
  ];

  connect() {
    this.updateConfirmBasedOnPlan();
  }

  get willChangePlanIfAddDentist() {
    return JSON.parse(this.data.get("willChangePlan")) && this.professionalTypeTarget.value === "dentist"
  }

  updateConfirmBasedOnPlan() {
    if (!this.data.get("newProfessional")) return
    if (this.hasDentistLimitMessageTarget) {
      this.dentistLimitMessageTarget.classList.toggle("tw-hidden", !this.willChangePlanIfAddDentist)
    }
    if (!this.willChangePlanIfAddDentist) {
      this.submitTarget.removeAttribute("data-confirm-sweet")
      this.submitTarget.removeAttribute("data-confirm-sweet-html")
      this.submitTarget.removeAttribute("data-confirm-sweet-confirm-text")
      return
    }

    this.submitTarget.setAttribute("data-confirm-sweet", "Seu plano será alterado")
    this.submitTarget.setAttribute("data-confirm-sweet-confirm-text", "Continuar")
    this.submitTarget.setAttribute("data-confirm-sweet-html", this.htmlForconfirmSweetPlanChangeTarget.innerHTML)
  }
}
